import { css } from '@styled-system/css';
import type { FC } from 'react';

interface SearchBarProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
}

export const SearchBar: FC<SearchBarProps> = ({
  placeholder = 'Rechercher une analyse',
  value = '',
  onChange,
  className,
}) => {
  const searchBarStyles = css({
    bg: 'base.border', // border
    h: '1.75rem', // 28px
    borderRadius: 'xl', // 99px
    display: 'flex',
    alignItems: 'center',
    px: 'sm', // 10px
    py: 'xs', // 5px
    w: '100%',
  });

  const inputStyles = css({
    bg: 'transparent',
    border: 'none',
    outline: 'none',
    fontSize: '2xs', // 9px
    fontWeight: 500,
    color: 'font.secondary', // font-lowkey
    w: '100%',
    '&::placeholder': {
      color: 'font.lowkey',
      opacity: 0.7,
    },
  });

  return (
    <div className={`${searchBarStyles} ${className || ''}`}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className={inputStyles}
      />
    </div>
  );
};
